import { render } from "./ChatPanel.vue?vue&type=template&id=1b6ec21c"
import script from "./ChatPanel.vue?vue&type=script&lang=js"
export * from "./ChatPanel.vue?vue&type=script&lang=js"

import "./ChatPanel.vue?vue&type=style&index=0&id=1b6ec21c&lang=scss"

import exportComponent from "/Users/wanghan/hanv3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__